<template>
  <div id="channelPacket">
    <el-main v-loading="isLoading" element-loading-text="loading" element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.1)">
      <template v-if="limit">
        <div class="header_p">部署扫码客户端</div>

        <div class="channel_conent">

          <div class="zip_channel">
            <p class="title_head">部署扫码包方法一：<span style="color: rgb(245, 108, 108);font-size: 14px;">可一键启动客户端，但会从服务器拉取最新安装包，约15M，会占用网吧下行流量，可能会影响客户端启动速度</span></p>
            <div class="thing2">
              <!-- <img src="../assets/zip.png" alt /> -->

              <a v-bind:href="file_url_2" class="scanning" ref="down">
                <el-button type="goon" size="medium">下载扫码包</el-button>
              </a>

              <a href="/favicon.ico" target="_blank" download="yebao" style="margin-left: 24px;">
                  <el-button type="danger" size="medium">下载ICO图标</el-button>
                </a>

              <div class="alldown_package" v-if="file_url_2 !=='' ">
                扫码包：
                <span>{{file_url_2}}</span>
              </div>
              <div style="color:#F56C6C;font-size:14px;margin-top:10px">
                扫码版安装说明：下载扫码版zip文件，解压文件，解压后的配置文件和启动程序必须在同目录，网吧服务器将luancher启动程序下发至客户机快捷方式即可，无需做开机启动。
              </div>

            </div>
          </div>
          <div class="zip_channel">
            <p class="title_head">部署扫码包方法二：<span style="color: rgb(245, 108, 108);font-size: 14px;">可自动更新服务器安装包，不需要网维手动更新版本，不占用网吧下行流量，举荐使用此方法</span></p>
            <div class="thing2" style="margin-bottom:30px">
              <!-- <img src="../assets/zip.png" alt /> -->

              <a v-bind:href="sm_downloadurl" class="scanning" ref="down">
                <el-button type="goon" size="medium">下载扫码通用包</el-button>
              </a>
              <div class="alldown_package">


                扫码通用包：
                <span>{{sm_downloadurl}}</span>
              </div>
            </div>
            <div class="thing2">
              <a v-bind:href="sm_configurl" class="scanning" ref="down">
                <el-button type="goon" size="medium">下载配置文件</el-button>
              </a>
              <div class="alldown_package">
                配置文件：
                <span>{{sm_configurl}}</span>
              </div>
            </div>
            <div style="color:#F56C6C;font-size:14px;margin-top:20px">
              扫码版安装说明：
              <p>1、下载扫码通用包和配置文件，并放在同目录下。</p>
              <p>2、双击运行扫码通用包ybService.exe程序，将自动拉取最新客户端到当前目录</p>
              <p>3、将拉取下来的客户端里面的YeBao.exe下发到客户机桌面快捷方式即可</p>
              <p>注意：ybService.exe为自动更新程序，请不要结束进程；请保持所有文件在同一目录</p>
            </div>
          </div>

          <!-- <div class="zip_channel">
            <p class="title_head">部署扫码静默安装包.exe</p>
            <div class="thing2">
              <div class="alldown">
                <div>
                  <a v-bind:href="file_url_4" class="scanning"> <el-button type="goon" size="medium">部署扫码静默安装包.exe </el-button></a>
                </div>
                <div class="alldown_package" v-if="file_url_4 !=='' ">
                  扫码静默安装包：
                  <span>{{file_url_4}}</span>
                </div>
              </div>
            </div>
          </div> -->


          <!-- <div class="addd">
            <p class="title_head">开机程序包</p>
            <div class="switvch">
              <el-switch
                active-text="开启"
                inactive-text="关闭"
                v-model="value2"
                active-color="#13ce66"
                @change="change($event)"
                inactive-color="#ff4949"
              ></el-switch>
            </div>
            <div class="thing2">
              <div class="alldown">
                <div>
                  <img src="../assets/xiazai.png" />
                  <a
                    href="http://dl.js.jixianjiasu.com/start_gg/jsqgg.exe"
                    class="scanning"
                    style="padding-left:30px"
                  >下载开机程序</a>
                </div>
                <div class="alldown_package">
                  开机程序：
                  <span>http://dl.js.jixianjiasu.com/start_gg/jsqgg.exe</span>

                  
                  <div class="explain" @click="open()">
                    <el-button type="primary">安装说明</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

        </div>
      </template>
    </el-main>

    <!-- <el-dialog title="安装说明" :visible.sync="dialogVisible" width="44%">
      <img src="../assets/jt.png" alt class="title_img" />
      <span
        class="explain"
      >说明： 请将该开机程序放到极限电竞加速器客户端下面，并设置为开机启动，请不要修改该目录下极限电竞加速器的启动程序名称（SpeedClient），否则将不能统计有效终端，一个终端累计运行达到90分钟及以上，为一个有效终端，一个终端一天统计一次，终端数据实时显示。</span>
    </el-dialog> -->
  </div>
</template>

<script>
  import * as sysApi from "../common/sys";
  export default {
    name: "channelPacket",
    data() {
      return {
        isLoading: false,
        limit: true,
        file_url_2: "",
        file_url_1: "",
        file_url_3: "",
        file_url_4: "",
        value2: "",
        dialogVisible: false,
        sm_configurl: "",
        sm_downloadurl: ""
      };
    },
    created() {
      this.getdown();
      this.sm_configurl = "https://new-file.yebaojiasu.com/api/v1/new_file/sm_config?account_number=" + localStorage
        .agent_number;
      this.sm_downloadurl = "https://dl-js.yebaojiasu.com/other/ybService.exe";
      // this.initSwitch();
    },
    methods: {
      getdown() {
        let _this = this;
        let pamrs = localStorage.getItem("agent_number");
        let account_number = "account_number=" + pamrs;
        console.log(account_number);
        sysApi.sm_downloads(account_number).then(res => {
          console.log(res);
          _this.limit = true;
          _this.file_url_2 = res.result.sm_zip_url;
          // _this.file_url_1 = res.result.by_zip_url;
          // _this.file_url_3 = res.result.by_exe_url;
          // _this.file_url_4 = res.result.sm_exe_url;
        });
      },
      open() {
        this.dialogVisible = true;
      },
      // 开关的状态
      initSwitch() {
        sysApi.open_close_get().then(res => {
          if (res.code != 1) {
            return this.$message.error(res.result);
          }
          if (res.result == 0) {
            this.value2 = false;
          } else {
            this.value2 = true;
          }
        });
      },
      // 点击
      change(val) {
        if (val) {
          this.getSwich(1); // 0 是关闭    1 是开启
        } else {
          this.getSwich(0);
        }
      },
      getSwich(val) {
        let pamrs = {
          is_open: val
        };
        sysApi.open_close(pamrs).then(res => {
          if (res.code != 1) {
            return this.$message.error(res.result);
          }
          this.$message.success(res.result);
        });
      }
    }
  };
</script>

<style scoped lang="scss">
  .title_img {
    width: 800px;
    height: 500px;
  }

  .explain {
    padding-top: 20px;
    color: #39c2b8;
    font-weight: bold;
    padding-right: 50px;
    font-size: 16px;
  }

  .addd {
    position: relative;
  }

  .switvch {
    position: absolute;
    top: 40px;
    left: 40%;
  }

  .scanning {
    // background: #6692ff;
    // line-height: 40px;
    // padding-left: 20px;
  }

  .alldown_package {
    margin-top: 20px;
    font-size: 16px;

    span {
      color: #5f95cc;
    }
  }

  .channel_conent {
    // border: 1px solid #bbbbbb;

    .zip_channel {
      // border-bottom: 1px solid #bbbbbb;
      background-color: #fff;
      margin-bottom: 30px;
      padding: 30px 20px;

      .title_head {
        margin: 0;
        line-height: 20px;
        font-size: 16px;
        color: #535353;
        margin-bottom: 20px;
      }

      .thing2 {
        padding: 0;
      }

      // padding-bottom: 70px;
    }
  }

  .header_p {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #535353;
  }


  .all_price span {
    font-size: 22px;
    font-weight: bold;
    color: #000;
  }

  .headerData,
  .alldown {
    div {
      position: relative;

      img {
        position: absolute;
        top: 10px;
        left: 8px;
        width: 20px;
        height: 20px;
      }
    }
  }

  #ul_firest li {
    flex: 3;
  }


  .thing,
  .thing2 {
    overflow: hidden;
    padding-left: 50px;
    padding-bottom: 10px;

  }

  .thing {
    position: relative;

    img {
      position: absolute;
      top: 10px;
      left: 60px;
      width: 20px;
      height: 20px;
    }
  }

  .thing a {
    // float: left;

    // color: #fff;
    // width: 180px;
    // text-align: center;
    // border-radius: 0px;
    // padding: 10px 20px;

    // margin-right: 40px;
  }

  .thing2 a {
    // color: #fff;
    // width: 180px;
    // text-align: center;
    // margin-bottom: 10px;
    // border-radius: 0px;
    // padding: 10px 20px;

  }

  .thing .download_span {
    float: left;
    color: #000;
    border-radius: 0px;
    padding: 10px 20px;
    margin-right: 40px;
  }

  .thing>li {
    float: left;
    margin: 5px 10px;
    list-style: none;
    padding: 10px;
    cursor: pointer;
    border-bottom: 1px solid #eee;
    background: #fff;

    color: #666;
  }

  .thing>li>a {
    color: #666;
  }

  .thing>li>a>p {
    overflow: hidden;
  }

  .thing>li>a>p>span:nth-child(1) {
    float: left;
  }

  .thing>li>a>p>span:nth-child(2) {
    float: right;
    color: #ff0000;
  }

  .fun>li {
    float: left;
    list-style: none;
    margin-right: 15px;
  }
</style>